import { render, staticRenderFns } from "./WDDynamicTable.vue?vue&type=template&id=365630ae&"
import script from "./WDDynamicTable.vue?vue&type=script&lang=js&"
export * from "./WDDynamicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports